import $ from 'jquery';

// get site url
export function siteUrl(){
	return $('html').data('siteurl');
}

// get theme path
export function themePath(){
	return $('html').data('themepath');
}

// are we running in debug mode?
export function debugMode(){
	return $('body').hasClass('debug');
}

// is window hidden? (inactive tab, minimised, completely covered, etc)
var hidden; 
if(typeof document.hidden !== "undefined") hidden = "hidden";
else if(typeof document.msHidden !== "undefined") hidden = "msHidden";
else if(typeof document.webkitHidden !== "undefined") hidden = "webkitHidden";

// set cookie
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

// trigger a resize event once all loaded
$(window).on("load", function(){
	$(window).trigger('resize');
});

// try to detect touch devices
function hasTouch() {
	return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
$(function(){
	if(hasTouch()) $('body').addClass('touch');
});